import { createSelector } from '@reduxjs/toolkit';
import { isEmpty, reduce } from 'lodash';
import { getAvailableRoomTypes } from './propertyAvailabilitySelectors';

export const getGa4Pricing = createSelector(getAvailableRoomTypes, (roomTypes) => {
  const ga4FirstOffer = roomTypes?.[0]?.offers?.[0];
  const ga4RoomOffers = reduce(
    roomTypes,
    (accum, room) => {
      const mappedRooms = () => {
        const roomOffers = reduce(
          room?.offers,
          (accum, offer) => {
            const roomOffer = {
              totalPayable: Number(offer?.charges?.total?.amount) || null,
              totalBeforeDiscount: Number(offer?.charges?.total?.amount) + Number(offer?.charges?.totalDiscount?.amount) || null,
              pointsEarned: offer?.pointsEarned?.qffPoints?.total || null,
              promotions: offer?.promotion?.name,
            };
            return [...accum, roomOffer];
          },
          [],
        );

        return roomOffers;
      };
      return [...accum, ...mappedRooms()];
    },
    [],
  );

  const offerCount = ga4RoomOffers?.length;

  const promotions = reduce(
    ga4RoomOffers,
    (accum, offer) => {
      if (!isEmpty(offer.promotions)) {
        return [...accum, offer.promotions];
      }
      return accum;
    },
    [],
  );

  const averagePrice = Math.floor(
    reduce(
      ga4RoomOffers,
      (accum, offer) => {
        return accum + offer?.totalPayable;
      },
      0,
    ) / offerCount,
  );

  const averagePriceBeforeDiscount = Math.floor(
    reduce(
      ga4RoomOffers,
      (accum, offer) => {
        return accum + offer?.totalBeforeDiscount;
      },
      0,
    ) / offerCount,
  );

  const averagePointsEarned = Math.floor(
    reduce(
      ga4RoomOffers,
      (accum, offer) => {
        return accum + offer?.pointsEarned;
      },
      0,
    ) / offerCount,
  );

  return {
    averagePrice,
    averagePriceBeforeDiscount,
    averagePointsEarned,
    offerCount,
    promotions,
    firstOffer: ga4FirstOffer,
  };
});
